__turbopack_context__.v({
  "bleed": "GiftFormSection-module__TVDcTa__bleed",
  "divider": "GiftFormSection-module__TVDcTa__divider",
  "dividerGapLg": "GiftFormSection-module__TVDcTa__dividerGapLg",
  "dividerGapMd": "GiftFormSection-module__TVDcTa__dividerGapMd",
  "dividerGapNone": "GiftFormSection-module__TVDcTa__dividerGapNone",
  "dividerGapSm": "GiftFormSection-module__TVDcTa__dividerGapSm",
  "dividerGapXl": "GiftFormSection-module__TVDcTa__dividerGapXl",
});
